import { StyledAuthor} from "@/components/styles";
import { ArrowButton, Picture } from "@/components";
import genLinkParams from "@/lib/generateLinkParams";
import Link from "next/link";



export default function Author(props) {
  const { id,  first_name, last_name, patronymic, position, qualification, preview, slug, ...otherProps   } = props;
  const [href, as] = genLinkParams({ type: 'specialist', slug });
  const title = `${last_name} ${first_name}${patronymic ? ' ' + patronymic : ''}`;
  const image = preview || {};

  return (
    <StyledAuthor {...otherProps}>
      <Link href={href} as={as} passHref>
        <StyledAuthor.Img>{Object.keys(image).length > 0 && <Picture {...image} />}</StyledAuthor.Img>
      </Link>

      <StyledAuthor.Info>
         <Link href={href} as={as} passHref>
            <StyledAuthor.Name>{title}</StyledAuthor.Name>
         </Link>
        {position && (
          <StyledAuthor.Desc>{position}</StyledAuthor.Desc>
        )}
      </StyledAuthor.Info>
    </StyledAuthor>
  );
}
